import intellifloPlanTypes from "../data/intellifloPlanTypes.json";

const IO_FIELDS = [
  ["portfolioCategory", "portfolioCategory"],
  ["productGroup", "productGroup"],
];

const clean = (value) => String(value ?? "").trim();

export const validatePlanTypeMappings = (
  mappings = [],
  ioItems = intellifloPlanTypes.items,
) => {
  const ioById = new Map(ioItems.map((item) => [clean(item.id), item]));
  const mappingsById = new Map(
    mappings.map((mapping) => [clean(mapping.planTypeId), mapping]),
  );
  const missing = ioItems.filter((item) => !mappingsById.has(clean(item.id)));
  const unexpected = mappings.filter(
    (mapping) => !ioById.has(clean(mapping.planTypeId)),
  );
  const mismatched = [];

  mappings.forEach((mapping) => {
    const ioItem = ioById.get(clean(mapping.planTypeId));
    if (!ioItem) return;
    const fields = IO_FIELDS.filter(
      ([mappingField, ioField]) =>
        clean(mapping[mappingField]) !== clean(ioItem[ioField]),
    ).map(([mappingField, ioField]) => ({
      field: mappingField,
      current: clean(mapping[mappingField]),
      expected: clean(ioItem[ioField]),
    }));
    if (fields.length) {
      mismatched.push({
        planTypeId: clean(mapping.planTypeId),
        planTypeName: mapping.planTypeName || ioItem.name,
        fields,
        expected: ioItem,
      });
    }
  });

  return {
    isMatch:
      missing.length === 0 &&
      unexpected.length === 0 &&
      mismatched.length === 0,
    checkedCount: mappings.length,
    referenceCount: ioItems.length,
    missing,
    unexpected,
    mismatched,
  };
};
